import { jsx as _jsx } from "preact/jsx-runtime";
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { RetentionModalCTX, retentionModalDefaultConfig } from '@widgets/RetentionModal/types/config';
import { useMemo } from 'react';
import Modal from '@widgets/RetentionModal/components/Modal';
import { FormProvider, useForm } from 'react-hook-form';
import { retentionFormSchema } from '@widgets/RetentionModal/validation/schema';
import { yupResolver } from '@hookform/resolvers/yup';
function RetentionModal({ dataset }) {
    const data = convertDataAttributes(dataset ?? {});
    const options = useMemo(() => ({
        ...retentionModalDefaultConfig,
        ...data,
    }), [data]);
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(retentionFormSchema),
    });
    return (_jsx(RetentionModalCTX.Provider, { value: options, children: _jsx(FormProvider, { ...form, children: _jsx(Modal, {}) }) }));
}
export default RetentionModal;
